import { MdDashboard, MdSettings } from "react-icons/md";
import { FaUsers, FaBlog } from "react-icons/fa";
import { BiCategory, BiPackage } from "react-icons/bi";
import { LiaChalkboardTeacherSolid } from "react-icons/lia";
import { ImStatsDots } from "react-icons/im";
import { FaHistory, FaBriefcase, FaUserFriends } from "react-icons/fa";
import { SiGnuprivacyguard } from "react-icons/si";

export const sidebarItems = [
  {
    id: 1,
    label: "Dashboard",
    parent_id: null,
    icon: <MdDashboard size={20} />,
    module: "dashboard",
    order_index: 1,
    url: "/admin/dashboard",
  },
  {
    id: 2,
    label: "Services",
    parent_id: null,
    icon: <FaUsers size={20} />,
    module: "services",
    order_index: 2,
    url: "/admin/services",
  },
  {
    id: 13,
    label: "Works",
    parent_id: null,
    icon: <BiPackage size={20} />,
    module: "works",
    order_index: 2.5,
    url: "/admin/works",
  },
  {
    id: 3,
    label: "Clients",
    parent_id: null,
    icon: <BiCategory size={20} />,
    module: "clients",
    order_index: 3,
    url: "/admin/clients",
  },
  {
    id: 4,
    label: "Testimonial",
    parent_id: null,
    icon: <BiPackage size={20} />,
    module: "testimonial",
    order_index: 4,
    url: "/admin/testimonial",
  },
  {
    id: 5,
    label: "Marquee",
    parent_id: null,
    icon: <BiPackage size={20} />,
    module: "marquee",
    order_index: 5,
    url: "/admin/marquee",
  },
  {
    id: 17,
    label: "Blogs",
    parent_id: null,
    icon: <FaBlog size={20} />,
    module: "blogs",
    order_index: 5.5,
    url: "/admin/blogs",
  },
  {
    id: 18,
    label: "Blog Categories",
    parent_id: null,
    icon: <BiCategory size={20} />,
    module: "blogs",
    order_index: 5.6,
    url: "/admin/blog-categories",
  },
  {
    id: 6,
    label: "Users",
    parent_id: null,
    icon: <LiaChalkboardTeacherSolid size={20} />,
    module: "users",
    order_index: 6,
    url: "/admin/users",
    roles: ["superadmin"],
  },
  {
    id: 9,
    label: "Contacts",
    parent_id: null,
    icon: <BiPackage size={20} />,
    module: "contacts",
    order_index: 5,
    url: "/admin/contacts",
  },
  {
    id: 10,
    label: "FAQ",
    parent_id: null,
    icon: <BiPackage size={20} />,
    module: "faq",
    order_index: 10,
    url: "/admin/faq",
  },
  {
    id: 11,
    label: "Stats",
    parent_id: null,
    icon: <ImStatsDots size={20} />,
    module: "stats",
    order_index: 11,
    url: "/admin/stats",
  },
  {
    id: 12,
    label: "Timeline",
    parent_id: null,
    icon: <FaHistory size={20} />,
    module: "timeline",
    order_index: 12,
    url: "/admin/timeline",
  },
  {
    id: 14,
    label: "Jobs",
    parent_id: null,
    icon: <FaBriefcase size={20} />,
    module: "jobs",
    order_index: 2.6,
    url: "/admin/jobs",
  },
  {
    id: 16,
    label: "Job Categories",
    parent_id: null,
    icon: <BiCategory size={20} />,
    module: "jobs",
    order_index: 2.55,
    url: "/admin/job-categories",
  },
  {
    id: 15,
    label: "Applications",
    parent_id: null,
    icon: <FaUserFriends size={20} />,
    module: "applications",
    order_index: 2.7,
    url: "/admin/applications",
  },
  {
    id: 19,
    label: "Site Settings",
    parent_id: null,
    icon: <MdSettings size={20} />,
    module: "settings",
    order_index: 20,
    url: "/admin/settings",
  },
  {
    id: 21,
    label: "Project Vault",
    parent_id: null,
    icon: <SiGnuprivacyguard size={20} />,
    module: "vault",
    order_index: 21,
    url: "/admin/project-vault",
    roles: ["superadmin"],
  },
];
